import { FeedbackDTO, FeedbackRequestDTO } from '@/models';
import { axiosBase } from './axios-base';

export const buildFeedbackRequestFormData = (requestData: FeedbackRequestDTO): FormData => {
  const formData = new FormData();
  formData.append('type', requestData.type);
  formData.append('description', requestData.description);
  formData.append('status', requestData.status);
  if (requestData.image) {
    formData.append('image', requestData.image);
  }
  return formData;
};

export const fetchFeedbacks = (): Promise<{ data: FeedbackDTO[] }> => {
  return axiosBase.get('/api/feedbacks');
};

export const createFeedback = (requestData: FeedbackRequestDTO): Promise<{ data: FeedbackDTO }> => {
  const body = buildFeedbackRequestFormData(requestData);
  return axiosBase.post('/api/feedback', body);
};

export const updateFeedbackStatus = (body: FeedbackDTO): Promise<{ data: FeedbackDTO }> => {
  return axiosBase.put('/api/feedback/updateStatus', body);
};
